/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_failed': {
    width: 16,
    height: 16,
    viewBox: '0 0 543.987 543.987',
    data: '<path pid="0" d="M85.265 74.203C-23.952 177.311-28.901 349.431 74.207 458.647a248.962 248.962 0 005.526 5.684c106.203 106.209 278.398 106.209 384.596 0 106.209-106.198 106.209-278.393 0-384.596C360.297-24.391 192.3-26.844 85.265 74.203zm52.166 117.065l53.841-53.841 80.765 80.765 80.765-80.765 53.847 53.841-80.765 80.792 80.77 80.737-53.847 53.847-80.765-80.77-80.765 80.77-53.841-53.847 80.759-80.737-80.764-80.792z" _fill="#010002"/>'
  }
})
